import React from 'react';
import { Helmet } from 'react-helmet';

const faqs = [
    {
        question: "What does Anmatics do?",
        answer: "Anmatics builds reliable software for companies that need SaaS platforms, enterprise web applications, AI workflow automation, cloud APIs, and legacy system modernization. The team focuses on structured engineering, maintainable architecture, and production-ready delivery."
    },
    {
        question: "Does Anmatics build SaaS platforms?",
        answer: "Yes. Anmatics designs and develops SaaS platforms including dashboards, admin panels, user workflows, APIs, integrations, release flows, and scalable architecture for products moving from MVP to production growth."
    },
    {
        question: "Can Anmatics modernize existing software?",
        answer: "Yes. Anmatics helps modernize existing Angular, React, Node.js, .NET, database, and cloud systems by improving architecture, performance, maintainability, deployment flow, and long-term product stability."
    },
    {
        question: "Does Anmatics provide AI workflow automation?",
        answer: "Yes. Anmatics creates AI-enabled workflows that reduce manual work, connect business systems, process data, support decisions, and automate repetitive operational steps using practical integrations and secure software architecture."
    },
    {
        question: "What technologies does Anmatics work with?",
        answer: "Anmatics works with React, Angular, TypeScript, Node.js, .NET, REST APIs, SQL Server, PostgreSQL, MongoDB, Azure, AWS, OpenAI APIs, workflow automation tools, and reporting systems."
    },
    {
        question: "How does Anmatics start a new project?",
        answer: "Anmatics starts with a technical consultation to understand the business goal, current system, constraints, timeline, and risks. The next step is a practical roadmap covering architecture, scope, technology, and delivery priorities."
    }
];

const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
        }
    }))
};

const AEOFAQ = () => {
    return (
        <section id="faq" className="aeo-faq-section py-5">
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(faqSchema)}
                </script>
            </Helmet>
            <div className="container" data-aos="fade-up">
                <div className="row g-4 align-items-start">
                    <div className="col-lg-4">
                        <div className="section-intro-sticky">
                            <span className="section-kicker">Answers</span>
                            <h2 className="section-title fw-bold text-start">Clear answers about working with Anmatics.</h2>
                            <p className="section-subtitle text-muted text-start mb-0">
                                Direct answers for founders, operators, and technology teams evaluating a software engineering partner.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="aeo-faq-list">
                            {faqs.map((faq, index) => (
                                <article className="aeo-faq-item" key={faq.question}>
                                    <span>{String(index + 1).padStart(2, '0')}</span>
                                    <div>
                                        <h3>{faq.question}</h3>
                                        <p>{faq.answer}</p>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AEOFAQ;
